export * from './app-aside';
export * from './app-breadcrumbs';
export * from './app-footer';
export * from './app-header';
export * from './app-sidebar';
export * from './app-sidebar-footer';
export * from './app-sidebar-form';
export * from './app-sidebar-header';
export * from './app-sidebar-minimizer';
export * from './app-sidebar-nav';



// WEBPACK FOOTER //
// D:/desv/producao/hc/angular/adminHC/src/app/components/index.ts